// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("puzzle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.spinner {
  height: 40vmin;
  pointer-events: none;
  animation: App-logo-spin 2s infinite linear;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.imageOptionWrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: [top] 10vh [meat] 75vh [bottom] 10vh;
}

.top {
  grid-row: top;
  background: gainsboro;
  font-size: 3em;
  text-align: center;
  line-height: 5vw;
}

.bottom {
  grid-row: bottom;
  background: gray;
  color: white;
  text-align: center;
  font-size: 2em;
  cursor: pointer;
  line-height: 5vw;
}

.option0 {
  margin: auto;
  width: 16.5vw;
  grid-row: meat 1;
  grid-column: col 1;
}

.option1 {
  margin: auto;
  width: 16.5vw;
  grid-row: meat 1;
  grid-column: col 2;
}

.option2 {
  margin: auto;
  width: 16.5vw;
  grid-row: meat 1;
  grid-column: col 3;
}

.option3 {
  margin: auto;
  width: 16.5vw;
  grid-row: meat 2;
  grid-column: col 1;
}

.option4 {
  margin: auto;
  width: 16.5vw;
  grid-row: meat 2;
  grid-column: col 2;
}

.option5 {
  margin: auto;
  width: 16.5vw;
  grid-row: meat 2;
  grid-column: col 3;
}

/* carousel CSS */
.carousel {
  grid-row: meat;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  align-content: space-between;
}

.carousel__btn {
  height: 2rem;
  width: 2rem;
  /*
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 1.5rem;
  border: none;
  padding: 1rem;
  cursor: pointer;
  z-index: 1;
  transition: background-color 0.3s; */
}
/*
.carousel__btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.carousel__btn--prev {
  left: 0;
}
.carousel__btn--next {
  right: 0;
}*/
.carousel img {
  max-width: 100%;
  max-height: 100%;
  background-size: contain;
  background-position: center;
}
/*
.carousel__img:hover {
  transform: scale(1.05);
}*/

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,2CAA2C;EAC3C,gDAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX;;;;;;;;;;;sCAWoC;AACtC;AACA;;;;;;;;;EASE;AACF;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;;;EAGE;;AAEF;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.spinner {\n  height: 40vmin;\n  pointer-events: none;\n  animation: App-logo-spin 2s infinite linear;\n  content: url(\"puzzle.svg\");\n}\n\n.wrapper {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.imageOptionWrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: [top] 10vh [meat] 75vh [bottom] 10vh;\n}\n\n.top {\n  grid-row: top;\n  background: gainsboro;\n  font-size: 3em;\n  text-align: center;\n  line-height: 5vw;\n}\n\n.bottom {\n  grid-row: bottom;\n  background: gray;\n  color: white;\n  text-align: center;\n  font-size: 2em;\n  cursor: pointer;\n  line-height: 5vw;\n}\n\n.option0 {\n  margin: auto;\n  width: 16.5vw;\n  grid-row: meat 1;\n  grid-column: col 1;\n}\n\n.option1 {\n  margin: auto;\n  width: 16.5vw;\n  grid-row: meat 1;\n  grid-column: col 2;\n}\n\n.option2 {\n  margin: auto;\n  width: 16.5vw;\n  grid-row: meat 1;\n  grid-column: col 3;\n}\n\n.option3 {\n  margin: auto;\n  width: 16.5vw;\n  grid-row: meat 2;\n  grid-column: col 1;\n}\n\n.option4 {\n  margin: auto;\n  width: 16.5vw;\n  grid-row: meat 2;\n  grid-column: col 2;\n}\n\n.option5 {\n  margin: auto;\n  width: 16.5vw;\n  grid-row: meat 2;\n  grid-column: col 3;\n}\n\n/* carousel CSS */\n.carousel {\n  grid-row: meat;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  align-content: space-between;\n}\n\n.carousel__btn {\n  height: 2rem;\n  width: 2rem;\n  /*\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 1.5rem;\n  border: none;\n  padding: 1rem;\n  cursor: pointer;\n  z-index: 1;\n  transition: background-color 0.3s; */\n}\n/*\n.carousel__btn:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n.carousel__btn--prev {\n  left: 0;\n}\n.carousel__btn--next {\n  right: 0;\n}*/\n.carousel img {\n  max-width: 100%;\n  max-height: 100%;\n  background-size: contain;\n  background-position: center;\n}\n/*\n.carousel__img:hover {\n  transform: scale(1.05);\n}*/\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
